// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fi","catalogByServiceItem__title":"c-l_fj"};